import { axiosInstance } from "./AxiosDefaults";
import { rolesRoute } from "../constants/ApiRoutes";

export type ApiResponse<T> = {
  status?: "SUCCESS" | "ERROR";
  message?: string;
  result?: T;
};

export const getAllRoles = (): Promise<any> => {
  return axiosInstance.get(rolesRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};
